import type { RailwayRunner } from '@cli-types/next-adapter/railway.js'

export function pathRunner(version: string): RailwayRunner {
  return { bin: 'railway', prefix: [], source: 'path', version }
}
